"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomerSupportContainer = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _gyasi = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/peopleBlobs/gyasi.jpg"));

var _combined = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/peopleBlobs/combined.jpg"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none !important;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-left: -6%;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block !important;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none !important;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n    margin-left: 0 !important;\n    > div {\n      display: flex;\n      flex-direction: row-reverse;\n      width: 100%;\n      max-width: 100%;\n      justify-content: flex-end;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n    h5 {\n      font-size: 1em;\n      margin-left: 1em;\n      text-align: left;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 65%;\n    margin-top: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 70px;\n    margin-bottom: 20px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 30px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Title = _styledComponents.default.h1.withConfig({
  displayName: "CustomerSupport__Title",
  componentId: "sc-19faywn-0"
})(["font-weight:bold;line-height:44px;", ";"], _responsiveBreakpoints.default.phone(_templateObject()));

var CustomerSupportContainer = _styledComponents.default.div.withConfig({
  displayName: "CustomerSupport__CustomerSupportContainer",
  componentId: "sc-19faywn-1"
})(["z-index:1;display:flex;flex-direction:row;align-items:center;width:100%;margin-top:40px;", ";"], _responsiveBreakpoints.default.sd(_templateObject2()));

exports.CustomerSupportContainer = CustomerSupportContainer;

var WordWrapper = _styledComponents.default.div.withConfig({
  displayName: "CustomerSupport__WordWrapper",
  componentId: "sc-19faywn-2"
})(["margin-left:auto;width:580px;", ";", ";"], _responsiveBreakpoints.default.sd(_templateObject3()), _responsiveBreakpoints.default.tabletPortrait(_templateObject4()));

var CustomerSupportMicroCopy = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "CustomerSupport__CustomerSupportMicroCopy",
  componentId: "sc-19faywn-3"
})(["text-transform:uppercase;font-weight:500;"]);
var IconsWrapper = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "CustomerSupport__IconsWrapper",
  componentId: "sc-19faywn-4"
})(["text-align:center;margin-top:49px;margin-left:-32px !important;margin-right:0 !important;", ";"], _responsiveBreakpoints.default.phone(_templateObject5()));
var DesktopImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "CustomerSupport__DesktopImage",
  componentId: "sc-19faywn-5"
})(["", ""], _responsiveBreakpoints.default.sd(_templateObject6()));
var MobileImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "CustomerSupport__MobileImage",
  componentId: "sc-19faywn-6"
})(["display:none !important;", " ", ";", ""], _responsiveBreakpoints.default.sd(_templateObject7()), _responsiveBreakpoints.default.tablet(_templateObject8()), _responsiveBreakpoints.default.tabletPortrait(_templateObject9()));

function CustomerSupport(_ref) {
  var className = _ref.className;
  return _react.default.createElement(CustomerSupportContainer, {
    "data-selenium-id": "customer-support-container",
    className: className
  }, _react.default.createElement(DesktopImage, {
    src: _combined.default,
    width: 510,
    height: 703,
    loading: "lazy"
  }), _react.default.createElement(MobileImage, {
    src: _gyasi.default,
    width: 280,
    height: 337,
    loading: "lazy"
  }), _react.default.createElement(WordWrapper, null, _react.default.createElement(CustomerSupportMicroCopy, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.title"
  })), _react.default.createElement(Title, null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.subtitle"
  })), _react.default.createElement("div", {
    className: "m-bottom-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.description"
  })), _react.default.createElement(IconsWrapper, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.phoneAndEmail"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "calling",
    size: 28
  })), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.documentation"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "blog",
    size: 28
  })), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.community"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "lists",
    size: 28
  })))));
}

var _default = CustomerSupport;
exports.default = _default;